export default "__VITE_ASSET__kuNWlP$u__"